import { Component, OnInit } from '@angular/core';

import { ApiService } from '../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { GlobalService } from '../services/global.service';
import { LoadingScreenService } from "../services/loading-screen.service";
import { NavbarService } from '../services/navbar.service';

@Component({
  selector: 'app-similar-homes',
  templateUrl: './similar-homes.component.html',
  styleUrls: ['./similar-homes.component.css']
})
export class SimilarHomesComponent implements OnInit {

  ComId: number;
  ComName: string;
  Region: string;

  homeDesigns: any;

  constructor(
    private apiservice: ApiService,
    private router: Router,
    private globalService: GlobalService,
    private LoadingScreenService: LoadingScreenService,
    public nav: NavbarService
  ) {
    /** Loader start */
    let loaderService = this.LoadingScreenService;
    loaderService.display(true);

    this.ComId = Number(localStorage.getItem('ComID'));
    this.ComName = localStorage.getItem('ComName');
    this.Region = localStorage.getItem('Region');

    var r = this.router;
    if (this.ComId > 0) {
      this.apiservice.homeDesigns(this.ComId).subscribe(data => {
        if (data['status_code'] != 200) {
          this.globalService.showError(data['status_message']);
        }
        this.homeDesigns = data['finalResult'];
        if(this.homeDesigns <= 0){
          /** Loader Stop */
          let loaderService = this.LoadingScreenService;
          loaderService.display(false);
        }
      });
    } else {
      this.globalService.showError('Opps! we could not get the community');
      setTimeout(function () {
        r.navigate(['home-list/']);
      }, 3000);
    }
  }

  ngOnInit() {
    this.nav.show();
  }
  finalImageLoaded() {
     /** Loader Stop */
    let loaderService = this.LoadingScreenService;
    loaderService.display(false);
  }

}
